import React, { useEffect, useState } from "react";
import { Input, FormGroup, Label, Button } from "reactstrap";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllMerchants
} from "../../redux/actions/indexActions";

import { toast } from "react-toastify";
const EditPortfolio = () => {
  const { id } = useParams();

  const [formData, setFormData] = useState({
    merchant_id: "",
    name: "",
    video_url: "",
    status: 1,
    thumbnail: "",
  });
  const [errors, setErrors] = useState({});

  const {
    AuthReducer: { auth },
    indexReducer: { merchants }
  } = useSelector((state) => state);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const inputHandler = (e) => {
    const { name, value } = e.target;
    if (name === "thumbnail") {
      setFormData({ ...formData, [name]: e.target.files[0] });
    }
    if (name === "status") {
      setFormData({ ...formData, [name]: e.target.checked ? 1 : 0 });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  useEffect(() => {
    dispatch(getAllMerchants(auth.token));
  }, [auth]);

  const handleSubmit = () => {
    const form = new FormData();
    for (const key in formData) {
      form.append([key], formData[key]);
    }
    axios
      .put(`/api/admin/v1/update-merchant-portfolio/${id}`, form, {
        headers: {
          Authorization: `Bearer ${auth?.token}`,
        },
      })
      .then((res) => {
        toast.success(res.data?.message);
        navigate(-1);
      })
      .catch((err) => {
        toast.error(err.response.data);
        setErrors(err.response.data);
      });
  };

  useEffect(() => {
    axios(`/api/admin/v1/edit-merchant-portfolio/${id}`, {
      headers: {
        Authorization: `Bearer ${auth?.token}`,
      },
    })
      .then((res) => {
        console.log(res.data, 'data');
        setFormData({
          merchant_id: res.data?.merchantportfolio?.merchant_id,
          name: res.data?.merchantportfolio?.name,
          video_url: res.data?.merchantportfolio?.video_url,
          status: res.data?.merchantportfolio?.status,
        });
      })
      .catch((err) => console.log(err));
  }, [auth]);



  return (
    <div>
      <div className="row my-3">
        <div className="col-md-12">
          <h4 className="text-white">Edit Portfolio</h4>
        </div>
      </div>
      <div className="bg-white px-3 py-4 rounded-2  my-4">
        <div className="row">
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Merchant <span className="text-danger fs-4">*</span></Label>
              <Input
              invalid={Boolean(errors?.merchant_id)}
                value={formData?.merchant_id}
                type="select"
                name="merchant_id"
                onChange={inputHandler}
              >
                <option value="">Select Merchant</option>
                {merchants?.map?.((item) => {
                  return (
                    <option value={item.id} key={item.id}>
                      {item?.name}
                    </option>
                  );
                })}
              </Input>
              <span className="d-block text-danger">{errors?.merchant_id}</span>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Name <span className="text-danger fs-4">*</span></Label>
              <Input
                invalid={Boolean(errors?.name)}
                value={formData?.name}
                name="name"
                onChange={inputHandler}
              />
              <span className="d-block text-danger"> {errors?.name} </span>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Video URL <span className="text-danger fs-4">*</span></Label>
              <Input
                value={formData?.video_url}
                invalid={Boolean(errors?.video_url)}
                name="video_url"
                onChange={inputHandler}
              />
              <span className="d-block text-danger">{errors?.video_url}</span>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Upload Thumbnail</Label>
              <Input
                type="file"
                invalid={Boolean(errors?.thumbnail)}
                name="thumbnail"
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    [e.target.name]: e.target.files[0],
                  }))
                }
              />
              <span className="d-block text-danger">{errors?.thumbnail}</span>
            </FormGroup>
          </div>

          <div className="col-md-4 offset-md-1">
            <FormGroup switch>
              <Input
                type="switch"
                checked={formData?.status}
                onChange={inputHandler}
                name="status"
              />
              <Label check>Status</Label>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-4">
            <Button color="primary" onClick={handleSubmit}>
              Submit
            </Button>
            <Button className="ms-3" onClick={() => navigate(-1)}>
              Cancel
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditPortfolio;
